import { render, staticRenderFns } from "./TheDocumentPackagers.vue?vue&type=template&id=83249330&scoped=true&"
import script from "./TheDocumentPackagers.vue?vue&type=script&lang=js&"
export * from "./TheDocumentPackagers.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentPackagers.vue?vue&type=style&index=0&id=83249330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83249330",
  null
  
)

export default component.exports